var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 17,
    height: 17,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(0 0.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(0 -0.725)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M7.716,0H8.745a.913.913,0,0,0,.124.026A7.834,7.834,0,0,1,12.332,1.1a8.123,8.123,0,0,1,4,5.714c.056.3.085.6.126.9V8.745a.921.921,0,0,0-.027.124A7.928,7.928,0,0,1,15.1,12.756a8.117,8.117,0,0,1-5.436,3.577c-.3.057-.613.086-.919.128H7.716a.931.931,0,0,0-.123-.027,8.012,8.012,0,0,1-4.408-1.708A8.088,8.088,0,0,1,.123,9.633C.071,9.339.04,9.041,0,8.745V7.716c.024-.2.044-.392.071-.587A8.091,8.091,0,0,1,2.125,2.716,8.061,8.061,0,0,1,6.828.124C7.123.073,7.42.041,7.716,0m.473,9.217.071-.005a.984.984,0,0,0,.108.161q1.208,1.213,2.42,2.421a1.373,1.373,0,0,0,.167.149.7.7,0,0,0,1.086-.381.724.724,0,0,0-.225-.743Q10.578,9.591,9.349,8.355c-.04-.04-.078-.082-.125-.132.282-.28.554-.546.823-.815q.893-.891,1.785-1.784a.708.708,0,1,0-.99-1.01Q9.6,5.849,8.364,7.093a.863.863,0,0,0-.1.175l-.753-.755C6.871,5.877,6.237,5.237,5.6,4.605a.708.708,0,1,0-.97,1.028Q5.861,6.865,7.093,8.1c.041.041.079.084.124.132-.048.05-.087.093-.128.133L5.736,9.717c-.383.383-.769.761-1.146,1.149a.708.708,0,1,0,1.035.964Q6.856,10.6,8.09,9.363a.941.941,0,0,0,.1-.145",
    transform: "translate(0 0.539)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.bbc4bbeced3fbc95d93d14da7225ef72.svg";
export { ForwardRef as ReactComponent };